module.exports = __webpack_public_path__ + "img/contact_3.bd4fd25c.png";